// Feature-flag gate for Ask Bizminer (CHAT-12). Same shape as
// Profiles/SelectorBeta/flag.js: the PostHog singleton main.js initialised, a
// hard default of HIDDEN, and nothing ever throws into the page.
//
// The flag `bizminer-chat` is the beta list. chat.bizminer.com re-checks the
// same flag server-side for the signed-in uid (403 not_in_beta), so this gate
// only decides whether the entry points are shown; it is not the security
// boundary. Flag evaluation needs a real browser UA: PostHog filters bot-like
// user agents (headless test runners) and the flag then never resolves, which
// leaves the button hidden.
import posthog from 'posthog-js';

export const CHAT_FLAG = 'bizminer-chat';

// true for boolean true or any variant that is not an explicit "off" word.
export function isFlagOn(v) {
  if (v === true) return true;
  if (typeof v === 'string') return !['', 'off', 'false', 'control', 'classic'].includes(v.toLowerCase());
  return false;
}

export function readChatFlag() {
  try {
    return isFlagOn(posthog.getFeatureFlag(CHAT_FLAG));
  } catch (e) {
    return false;
  }
}

// Calls cb(boolean) now (from posthog's cached flags; undefined = not loaded =
// false) and again every time flags (re)load, e.g. after identify() or a
// reload. Returns an unsubscribe function. Never throws.
export function watchChatFlag(cb) {
  let off = null;
  try {
    cb(readChatFlag());
    const un = posthog.onFeatureFlags(() => cb(readChatFlag()));
    off = typeof un === 'function' ? un : null;
  } catch (e) {
    cb(false);
  }
  return () => {
    try {
      if (off) off();
    } catch (e) {
      /* ignore */
    }
  };
}
